import React, { useEffect, useState } from "react";
import SelectFilter from '../../components/searchBar/SelectFilter';
import MenuItem from "@mui/material/MenuItem";
import { apiGetDAPPaymentChannel } from "../../resource/index.js";
import Storage from "../../common/lib/storage";

const DAPPaymentChannel = ({
  value,
  dataType,
  paymentMethod,
  onChange
}) => {
  const [paymentList, setPaymentList] = useState([]);
  const regulator = Storage.getRegulator() ?? "";

  useEffect(() => {
    if (dataType && paymentMethod) {
      apiGetDAPPaymentChannel(regulator, dataType, paymentMethod)
        .then((res) => {
          if (res.data.status === "success") {
            setPaymentList(res.data.data.paymentChannel);
            onChange('')
          }
        })
        .catch((e) => {
          setPaymentList([]);
        })
    } else {
      setPaymentList([]);
    }
  }, [regulator, dataType, paymentMethod]);

  return (
      <SelectFilter
          size="small"
          select
          variant="outlined"
          label="Payment Channel"
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            value: value || "",
            onChange: (e) => onChange(e.target.value || ""),
            displayEmpty: true,
          }}
      >
          <MenuItem value=""><em>All Channels</em></MenuItem>
          {paymentList.map(r => <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>)}
      </SelectFilter>
  )
}

export default DAPPaymentChannel;
